import { FilterModel } from "./filters.model";
import { LogicalOperator } from "../../enums/logical-operator.enum";

export class FilterInfoModel {
    logicalOperator: LogicalOperator = LogicalOperator.None;
    filters: FilterModel[] = [];
}
